// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/MARBLE-01-Black.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  box-sizing: border-box;
}

* {
  margin: 0;
  padding: 0;
  font-family: inherit;
  color: inherit;
}
*::before, *::after {
  box-sizing: inherit;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

li {
  list-style: none;
}
li ul, li ol {
  margin: 0;
  padding: 0;
}

img, video {
  max-width: 100%;
}

:root {
  --black: #292F36;
  --white: #F7FFF7;
  --coral: #fc814a;
  --teal: #4ECDC4
  --green: #c2e812;
  --yellow: #FFE66D;
  --page-margin-x: 1.2rem;
  --page-margin-y: 1.2rem;
  --gap-x: 1rem;
  --gap-y: 1rem;
}
@media only screen and (min-width: 360px) {
  :root {
    --page-margin-x: 2rem;
    --page-margin-y: 1.5rem;
  }
}
@media only screen and (min-width: 540px) {
  :root {
    --page-margin-x: 3.2rem;
    --page-margin-y: 2.4rem;
  }
}

body {
  background-color: var(--black);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  height: var(--doc-height);
  display: grid;
  place-items: center;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  overflow: hidden;
}

#root {
  width: 100%;
  max-width: 1200px;
  height: 100%;
  max-height: 800px;
  color: var(--white);
  font-family: "DM Sans", sans-serif;
  display: grid;
  grid-template-rows: min-content 1fr min-content;
  justify-items: stretch;
}
#root h1 {
  font-weight: 400;
  font-size: 1.8rem;
}
@media only screen and (min-width: 540px) {
  #root h1 {
    font-size: 2.4rem;
  }
}
#root p {
  font-weight: 300;
  font-size: 1rem;
}
#root a {
  text-decoration: none;
  font-weight: 300;
}
#root a:hover {
  text-decoration: underline;
}
#root svg {
  fill: var(--white);
}

header, main, footer {
  padding: var(--page-margin-y) var(--page-margin-x);
}

main {
  margin: calc(var(--page-margin-y) * -1 + var(--gap-y)) 0;
  display: grid;
  grid-auto-rows: min-content;
  gap: var(--gap-y) var(--gap-x);
}

#contact-page {
  --section-gap-x: 1em;
  --section-gap-y: 0.6em;
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--page-margin-y);
}
#contact-page section {
  display: flex;
  flex-direction: column;
  gap: var(--section-gap-y);
}
#contact-page section h1 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}
@media only screen and (min-width: 720px) {
  #contact-page section h1 {
    font-size: 1.8rem;
  }
}
#contact-page section ul {
  display: flex;
  flex-direction: column;
  gap: var(--section-gap-y);
}
#contact-page section li {
  display: flex;
  gap: var(--section-gap-x);
  align-items: center;
}
@media only screen and (min-width: 720px) {
  #contact-page {
    grid-template-columns: repeat(2, 1fr);
    gap: var(--page-margin-x);
  }
}

header {
  display: flex;
  align-items: end;
  gap: var(--page-margin-x);
}
header svg {
  width: 64px;
  fill: var(--white);
}
header nav {
  height: 100%;
}
header nav ul {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0 2rem;
  height: 100%;
  grid-template-rows: repeat(2, 32px);
  align-items: end;
}
header nav ul li {
  font-size: 0.9rem;
  line-height: 1em;
}
header nav ul a {
  text-decoration: none;
}
header nav ul a:hover {
  text-decoration: underline;
}
@media only screen and (min-width: 540px) {
  header nav ul {
    display: flex;
  }
}
header h2 {
  font-size: 1.2em;
  line-height: 1em;
  font-weight: 300;
}

footer {
  display: flex;
  gap: var(--page-margin-x);
  align-items: center;
  justify-content: stretch;
}

button {
  background: none;
  padding: var(--gap-y) var(--gap-x);
  border: 1px solid var(--white);
  transition: border-radius 0.2s;
  cursor: pointer;
  flex-grow: 1;
}
@media only screen and (min-width: 540px) {
  button {
    flex-grow: 0;
    padding: var(--gap-y) var(--page-margin-x);
  }
}
button:hover {
  border-radius: 1rem;
}
button:active {
  border-radius: 0;
}

.vsep {
  background-color: currentColor;
  min-height: 1px;
  margin: 0 var(--page-margin-x);
}

.card {
  border-radius: var(--page-margin-x);
  border: 1px solid var(--white);
  padding: var(--page-margin-y) var(--page-margin-x);
  display: grid;
  grid-auto-rows: min-content;
}`, "",{"version":3,"sources":["webpack://./src/sass/globals/_reset.scss","webpack://./src/sass/style.scss","webpack://./src/sass/globals/_theme.scss","webpack://./src/sass/globals/_breakpoints.scss","webpack://./src/sass/layout/_root.scss","webpack://./src/sass/layout/_pages.scss","webpack://./src/sass/components/_header.scss","webpack://./src/sass/components/_footer.scss","webpack://./src/sass/components/_button.scss","webpack://./src/sass/components/_vsep.scss","webpack://./src/sass/components/_card.scss"],"names":[],"mappings":"AAEA;EACI,sBAAA;ACAJ;;ADGA;EACI,SAAA;EACA,UAAA;EACA,oBAAA;EACA,cAAA;ACAJ;ADCI;EACI,mBAAA;ACCR;;ADKA;EACI,yBAAA;EACA,iBAAA;ACFJ;;ADKA;EACI,gBAAA;ACFJ;ADGI;EACI,SAAA;EACA,UAAA;ACDR;;ADKA;EACI,eAAA;ACFJ;;ACxBA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA;kBAAA;EAEA,iBAAA;EAEA,uBAAA;EACA,uBAAA;EAEA,aAAA;EACA,aAAA;ADyBF;AE/BQ;EDNR;IAeI,qBAAA;IACA,uBAAA;ED0BF;AACF;AErCQ;EDNR;IAoBI,uBAAA;IACA,uBAAA;ED2BF;AACF;;AGrDA;EACE,8BAAA;EACA,yDAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,uBAAA;EACA,gBAAA;AHwDF;;AGrDA;EACE,WAAA;EACA,iBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,kCAAA;EACA,aAAA;EACA,+CAAA;EACA,sBAAA;AHwDF;AGtDE;EACE,gBAAA;EACA,iBAAA;AHwDJ;AEtEQ;ECYN;IAII,iBAAA;EH0DJ;AACF;AGvDE;EACE,gBAAA;EACA,eAAA;AHyDJ;AGtDE;EACE,qBAAA;EACA,gBAAA;AHwDJ;AGvDI;EACE,0BAAA;AHyDN;AGrDE;EACE,kBAAA;AHuDJ;;AGnDA;EACE,kDAAA;AHsDF;;AGnDA;EACE,wDAAA;EACA,aAAA;EACA,2BAAA;EACA,8BAAA;AHsDF;;AI9GA;EACE,oBAAA;EACA,sBAAA;EACA,aAAA;EACA,0BAAA;EACA,yBAAA;AJiHF;AI/GE;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;AJiHJ;AI9GI;EACE,iBAAA;EAKA,mBAAA;AJ4GN;AErHQ;EEGJ;IAII,iBAAA;EJkHN;AACF;AI9GI;EACE,aAAA;EACA,sBAAA;EACA,yBAAA;AJgHN;AI7GI;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;AJ+GN;AEpIQ;EEVR;IAqCI,qCAAA;IACA,yBAAA;EJ6GF;AACF;;AKpJA;EACE,aAAA;EACA,gBAAA;EAEA,yBAAA;ALsJF;AKpJE;EACE,WAAA;EAEA,kBAAA;ALqJJ;AKlJE;EACE,YAAA;ALoJJ;AKjJE;EACE,aAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,mCAAA;EACA,gBAAA;ALmJJ;AKjJI;EACE,iBAAA;EACA,gBAAA;ALmJN;AKjJI;EACE,qBAAA;ALmJN;AKlJM;EACE,0BAAA;ALoJR;AEzKQ;EGMN;IAmBI,aAAA;ELoJJ;AACF;AKjJE;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;ALmJJ;;AM7LA;EACE,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,wBAAA;ANgMF;;AOpMA;EACE,gBAAA;EACA,kCAAA;EACA,8BAAA;EACA,8BAAA;EACA,eAAA;EACA,YAAA;APuMF;AEnMQ;EKVR;IASI,YAAA;IACA,0CAAA;EPwMF;AACF;AOvME;EACE,mBAAA;APyMJ;AOvME;EACE,gBAAA;APyMJ;;AQ3NA;EACE,8BAAA;EACA,eAAA;EACA,8BAAA;AR8NF;;AS/NA;EACE,mCAAA;EACA,8BAAA;EACA,kDAAA;EACA,aAAA;EACA,2BAAA;ATkOF","sourcesContent":["// global behavior\r\n\r\nhtml {\r\n    box-sizing: border-box;\r\n}\r\n\r\n* {\r\n    margin: 0;\r\n    padding: 0;\r\n    font-family: inherit;\r\n    color: inherit;\r\n    &::before, &::after {\r\n        box-sizing: inherit;\r\n    }\r\n}\r\n\r\n// specific element styles\r\n\r\ntable {\r\n    border-collapse: collapse;\r\n    border-spacing: 0;\r\n}\r\n\r\nli {\r\n    list-style: none;\r\n    ul, ol {\r\n        margin: 0;\r\n        padding: 0;\r\n    }\r\n}\r\n\r\nimg, video {\r\n    max-width: 100%;\r\n}","@import url(\"https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap\");\nhtml {\n  box-sizing: border-box;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  font-family: inherit;\n  color: inherit;\n}\n*::before, *::after {\n  box-sizing: inherit;\n}\n\ntable {\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\nli {\n  list-style: none;\n}\nli ul, li ol {\n  margin: 0;\n  padding: 0;\n}\n\nimg, video {\n  max-width: 100%;\n}\n\n:root {\n  --black: #292F36;\n  --white: #F7FFF7;\n  --coral: #fc814a;\n  --teal: #4ECDC4\n  --green: #c2e812;\n  --yellow: #FFE66D;\n  --page-margin-x: 1.2rem;\n  --page-margin-y: 1.2rem;\n  --gap-x: 1rem;\n  --gap-y: 1rem;\n}\n@media only screen and (min-width: 360px) {\n  :root {\n    --page-margin-x: 2rem;\n    --page-margin-y: 1.5rem;\n  }\n}\n@media only screen and (min-width: 540px) {\n  :root {\n    --page-margin-x: 3.2rem;\n    --page-margin-y: 2.4rem;\n  }\n}\n\nbody {\n  background-color: var(--black);\n  background-image: url(\"../assets/MARBLE-01-Black.jpg\");\n  height: var(--doc-height);\n  display: grid;\n  place-items: center;\n  grid-template-columns: 1fr;\n  grid-template-rows: 1fr;\n  overflow: hidden;\n}\n\n#root {\n  width: 100%;\n  max-width: 1200px;\n  height: 100%;\n  max-height: 800px;\n  color: var(--white);\n  font-family: \"DM Sans\", sans-serif;\n  display: grid;\n  grid-template-rows: min-content 1fr min-content;\n  justify-items: stretch;\n}\n#root h1 {\n  font-weight: 400;\n  font-size: 1.8rem;\n}\n@media only screen and (min-width: 540px) {\n  #root h1 {\n    font-size: 2.4rem;\n  }\n}\n#root p {\n  font-weight: 300;\n  font-size: 1rem;\n}\n#root a {\n  text-decoration: none;\n  font-weight: 300;\n}\n#root a:hover {\n  text-decoration: underline;\n}\n#root svg {\n  fill: var(--white);\n}\n\nheader, main, footer {\n  padding: var(--page-margin-y) var(--page-margin-x);\n}\n\nmain {\n  margin: calc(var(--page-margin-y) * -1 + var(--gap-y)) 0;\n  display: grid;\n  grid-auto-rows: min-content;\n  gap: var(--gap-y) var(--gap-x);\n}\n\n#contact-page {\n  --section-gap-x: 1em;\n  --section-gap-y: 0.6em;\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: var(--page-margin-y);\n}\n#contact-page section {\n  display: flex;\n  flex-direction: column;\n  gap: var(--section-gap-y);\n}\n#contact-page section h1 {\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n}\n@media only screen and (min-width: 720px) {\n  #contact-page section h1 {\n    font-size: 1.8rem;\n  }\n}\n#contact-page section ul {\n  display: flex;\n  flex-direction: column;\n  gap: var(--section-gap-y);\n}\n#contact-page section li {\n  display: flex;\n  gap: var(--section-gap-x);\n  align-items: center;\n}\n@media only screen and (min-width: 720px) {\n  #contact-page {\n    grid-template-columns: repeat(2, 1fr);\n    gap: var(--page-margin-x);\n  }\n}\n\nheader {\n  display: flex;\n  align-items: end;\n  gap: var(--page-margin-x);\n}\nheader svg {\n  width: 64px;\n  fill: var(--white);\n}\nheader nav {\n  height: 100%;\n}\nheader nav ul {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 0 2rem;\n  height: 100%;\n  grid-template-rows: repeat(2, 32px);\n  align-items: end;\n}\nheader nav ul li {\n  font-size: 0.9rem;\n  line-height: 1em;\n}\nheader nav ul a {\n  text-decoration: none;\n}\nheader nav ul a:hover {\n  text-decoration: underline;\n}\n@media only screen and (min-width: 540px) {\n  header nav ul {\n    display: flex;\n  }\n}\nheader h2 {\n  font-size: 1.2em;\n  line-height: 1em;\n  font-weight: 300;\n}\n\nfooter {\n  display: flex;\n  gap: var(--page-margin-x);\n  align-items: center;\n  justify-content: stretch;\n}\n\nbutton {\n  background: none;\n  padding: var(--gap-y) var(--gap-x);\n  border: 1px solid var(--white);\n  transition: border-radius 0.2s;\n  cursor: pointer;\n  flex-grow: 1;\n}\n@media only screen and (min-width: 540px) {\n  button {\n    flex-grow: 0;\n    padding: var(--gap-y) var(--page-margin-x);\n  }\n}\nbutton:hover {\n  border-radius: 1rem;\n}\nbutton:active {\n  border-radius: 0;\n}\n\n.vsep {\n  background-color: currentColor;\n  min-height: 1px;\n  margin: 0 var(--page-margin-x);\n}\n\n.card {\n  border-radius: var(--page-margin-x);\n  border: 1px solid var(--white);\n  padding: var(--page-margin-y) var(--page-margin-x);\n  display: grid;\n  grid-auto-rows: min-content;\n}","@use \"../globals/breakpoints\" as *;\r\n\r\n// font declarations\r\n@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap');\r\n\r\n// variables\r\n:root {\r\n  --black: #292F36;\r\n  --white: #F7FFF7;\r\n  --coral: #fc814a;\r\n  --teal: #4ECDC4\r\n  --green: #c2e812;\r\n  --yellow: #FFE66D;\r\n\r\n  --page-margin-x: 1.2rem;\r\n  --page-margin-y: 1.2rem;\r\n\r\n  --gap-x: 1rem;\r\n  --gap-y: 1rem;\r\n\r\n  @include break-at(\"mobile-m\") {\r\n    --page-margin-x: 2rem;\r\n    --page-margin-y: 1.5rem;\r\n  }\r\n\r\n  @include break-at(\"tablet-s\") {\r\n    --page-margin-x: 3.2rem;\r\n    --page-margin-y: 2.4rem;\r\n  }\r\n}","$breakpoints: (\r\n    \"mobile-m\": 360px,\r\n    \"mobile-l\": 420px,\r\n    \"tablet-s\": 540px,\r\n    \"laptop-s\": 720px,\r\n    \"laptop-l\": 1024px,\r\n    \"desktop-s\": 1200px,\r\n    \"desktop-m\": 1440px\r\n);\r\n\r\n@mixin break-at($size) {\r\n    @if map-has-key($breakpoints, $size) {\r\n        @media only screen and (min-width: map-get($breakpoints, $size)) {\r\n            @content;\r\n        }\r\n    }\r\n}","@use \"../globals/breakpoints\" as *;\r\n\r\nbody {\r\n  background-color: var(--black);\r\n  background-image: url(\"../assets/MARBLE-01-Black.jpg\");\r\n  height: var(--doc-height);\r\n  display: grid;\r\n  place-items: center;\r\n  grid-template-columns: 1fr;\r\n  grid-template-rows: 1fr;\r\n  overflow: hidden;\r\n}\r\n\r\n#root {\r\n  width: 100%;\r\n  max-width: 1200px;\r\n  height: 100%;\r\n  max-height: 800px;\r\n  color: var(--white);\r\n  font-family: \"DM Sans\", sans-serif;\r\n  display: grid;\r\n  grid-template-rows: min-content 1fr min-content;\r\n  justify-items: stretch;\r\n\r\n  h1 {\r\n    font-weight: 400;\r\n    font-size: 1.8rem;\r\n    @include break-at(\"tablet-s\") {\r\n      font-size: 2.4rem;\r\n    }\r\n  }\r\n\r\n  p {\r\n    font-weight: 300;\r\n    font-size: 1rem;\r\n  }\r\n\r\n  a {\r\n    text-decoration: none;\r\n    font-weight: 300;\r\n    &:hover {\r\n      text-decoration: underline;\r\n    }\r\n  }\r\n\r\n  svg {\r\n    fill: var(--white);\r\n  }\r\n}\r\n\r\nheader, main, footer {\r\n  padding: var(--page-margin-y) var(--page-margin-x);\r\n}\r\n\r\nmain {\r\n  margin: calc(var(--page-margin-y) * -1 + var(--gap-y)) 0;\r\n  display: grid;\r\n  grid-auto-rows: min-content;\r\n  gap: var(--gap-y) var(--gap-x);\r\n}","@use \"../globals/breakpoints\" as *;\r\n\r\n#contact-page {\r\n  --section-gap-x: 1em;\r\n  --section-gap-y: 0.6em; \r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  gap: var(--page-margin-y);\r\n\r\n  section {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: var(--section-gap-y);\r\n\r\n\r\n    h1 {\r\n      font-size: 1.5rem;\r\n  \r\n      @include break-at(\"laptop-s\") {\r\n        font-size: 1.8rem;\r\n      }\r\n      margin-bottom: 1rem;\r\n    }\r\n\r\n    ul {\r\n      display: flex;\r\n      flex-direction: column;\r\n      gap: var(--section-gap-y);\r\n    }\r\n\r\n    li {\r\n      display: flex;\r\n      gap: var(--section-gap-x);\r\n      align-items: center;\r\n    }\r\n\r\n  }\r\n\r\n  @include break-at(\"laptop-s\") {\r\n    grid-template-columns: repeat(2, 1fr);\r\n    gap: var(--page-margin-x);\r\n  }\r\n\r\n}","@use \"../globals/breakpoints\" as *;\r\n\r\nheader {\r\n  display: flex;\r\n  align-items: end;\r\n  // justify-content: space-between;\r\n  gap: var(--page-margin-x);\r\n  \r\n  svg {\r\n    width: 64px;\r\n    // height: 6rem;\r\n    fill: var(--white);\r\n  }\r\n\r\n  nav {\r\n    height: 100%;\r\n  }\r\n\r\n  nav ul {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr);\r\n    gap: 0 2rem;\r\n    height: 100%;\r\n    grid-template-rows: repeat(2, 32px);\r\n    align-items: end;\r\n    \r\n    li {\r\n      font-size: .9rem;\r\n      line-height: 1em;\r\n    }\r\n    a {\r\n      text-decoration: none;\r\n      &:hover {\r\n        text-decoration: underline;\r\n      }\r\n    }\r\n    @include break-at(\"tablet-s\") {\r\n      display: flex;\r\n    }\r\n  }\r\n  \r\n  h2 {\r\n    font-size: 1.2em;\r\n    line-height: 1em;\r\n    font-weight: 300;\r\n  }\r\n}","@use \"../globals/breakpoints\" as *;\r\n\r\nfooter {\r\n  display: flex;\r\n  gap: var(--page-margin-x);\r\n  align-items: center;\r\n  justify-content: stretch;\r\n}","@use \"../globals/breakpoints\" as *;\r\n\r\nbutton {\r\n  background: none;\r\n  padding: var(--gap-y) var(--gap-x);\r\n  border: 1px solid var(--white);\r\n  transition: border-radius 0.2s;\r\n  cursor: pointer;\r\n  flex-grow: 1;\r\n\r\n  @include break-at(\"tablet-s\") {\r\n    flex-grow: 0;\r\n    padding: var(--gap-y) var(--page-margin-x);\r\n  }\r\n  &:hover {\r\n    border-radius: 1rem;\r\n  }\r\n  &:active {\r\n    border-radius: 0;\r\n  }\r\n}",".vsep {\r\n  background-color: currentColor;\r\n  min-height: 1px;\r\n  margin: 0 var(--page-margin-x);\r\n}","@use \"../globals/breakpoints\" as *;\r\n\r\n.card {\r\n  border-radius: var(--page-margin-x);\r\n  border: 1px solid var(--white);\r\n  padding: var(--page-margin-y) var(--page-margin-x);\r\n  display: grid;\r\n  grid-auto-rows: min-content;\r\n\r\n  // @include break-at(\"small\") {\r\n  //   border-radius: 1rem;\r\n  //   gap: 1rem;\r\n  // }\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
